import { c as _c } from "react/compiler-runtime";
import { lazy } from 'react';
import EntityCardTitle from './EntityCardTitle';
const EntityImage = lazy(() => import('../EntityImage'));
const EntityCardMainContentTemplate = t0 => {
    const $ = _c(46);
    const { belowContent, hideLocation, href, image, information, isReservation, languages, light, location, rightContent, vertical, mapPopup, title, typeContent, children, maxTitleRows } = t0;
    const containerClassName = `flex ${vertical ? "flex-col" : "flex-row flex-grow"}`;
    const mainContainerClassName = `flex ${vertical ? "flex-col-reverse" : "flex-row-reverse w-full"}`;
    const imageContainerClassName = `flex flex-row max-w-full flex-shrink-0 ${mapPopup ? vertical ? "w-full" : "!min-w-28 !basis-1/3 h-full" : isReservation || rightContent ? vertical ? "w-full" : "w-40" : vertical ? "w-full" : "w-1/3 !max-w-80 min-w-68"}`;
    const imageClassName = `relative bg-gray-100 rounded overflow-hidden will-change-transform ${mapPopup ? vertical ? "h-47 w-full !rounded-none" : "min-h-32 w-full !rounded-none" : rightContent ? `h-30 ${vertical ? "w-1/2" : "w-full"}` : vertical ? "h-50 w-full" : `${isReservation ? "h-30" : "h-48"} w-full`}`;
    const contentClassName = `entity-content flex flex-col pt-2 ${mapPopup ? `px-4 ${vertical ? "py-2" : "w-2/3 !flex-shrink flex-grow-0"}` : vertical ? "" : "md:mt-0 md:ml-4 flex-grow"}`;
    const typeClassName = `entity-type text-xs uppercase font-semibold mb-1 ${mapPopup && !vertical ? "!text-xxs whitespace-nowrap max-w-full text-ellipsis overflow-hidden" : ""}`;
    let t1;
    if ($[0] !== href || $[1] !== information || $[2] !== isReservation || $[3] !== languages || $[4] !== light || $[5] !== mapPopup || $[6] !== maxTitleRows || $[7] !== title) {
        t1 = <EntityCardTitle href={href} title={title} information={information} languages={languages} light={light} mapPopup={mapPopup} isReservation={isReservation} maxTitleRows={maxTitleRows}/>;
        $[0] = href;
        $[1] = information;
        $[2] = isReservation;
        $[3] = languages;
        $[4] = light;
        $[5] = mapPopup;
        $[6] = maxTitleRows;
        $[7] = title;
        $[8] = t1;
    }
    else {
        t1 = $[8];
    }
    let t2;
    if ($[9] !== typeClassName || $[10] !== typeContent) {
        t2 = <p className={typeClassName}>{typeContent}</p>;
        $[9] = typeClassName;
        $[10] = typeContent;
        $[11] = t2;
    }
    else {
        t2 = $[11];
    }
    let t3;
    if ($[12] !== hideLocation || $[13] !== location) {
        t3 = !hideLocation && <p className="font-semibold text-sm text-gray-400 mb-1">{location}</p>;
        $[12] = hideLocation;
        $[13] = location;
        $[14] = t3;
    }
    else {
        t3 = $[14];
    }
    let t4;
    if ($[15] !== children || $[16] !== contentClassName || $[17] !== t1 || $[18] !== t2 || $[19] !== t3) {
        t4 = <div className={contentClassName}>{t1}{t2}{t3}{children}</div>;
        $[15] = children;
        $[16] = contentClassName;
        $[17] = t1;
        $[18] = t2;
        $[19] = t3;
        $[20] = t4;
    }
    else {
        t4 = $[20];
    }
    const t5 = !!href;
    let t6;
    if ($[21] !== image || $[22] !== t5) {
        t6 = <EntityImage image={image} hasLink={t5}/>;
        $[21] = image;
        $[22] = t5;
        $[23] = t6;
    }
    else {
        t6 = $[23];
    }
    let t7;
    if ($[24] !== imageClassName || $[25] !== t6) {
        t7 = <div className={imageClassName}>{t6}</div>;
        $[24] = imageClassName;
        $[25] = t6;
        $[26] = t7;
    }
    else {
        t7 = $[26];
    }
    let t8;
    if ($[27] !== rightContent) {
        t8 = rightContent && <div className="flex flex-col w-1/2 pl-4 self-stretch md:hidden">{rightContent}</div>;
        $[27] = rightContent;
        $[28] = t8;
    }
    else {
        t8 = $[28];
    }
    let t9;
    if ($[29] !== imageContainerClassName || $[30] !== t7 || $[31] !== t8) {
        t9 = <div className={imageContainerClassName}>{t7}{t8}</div>;
        $[29] = imageContainerClassName;
        $[30] = t7;
        $[31] = t8;
        $[32] = t9;
    }
    else {
        t9 = $[32];
    }
    let t10;
    if ($[33] !== mainContainerClassName || $[34] !== t4 || $[35] !== t9) {
        t10 = <div className={mainContainerClassName}>{t4}{t9}</div>;
        $[33] = mainContainerClassName;
        $[34] = t4;
        $[35] = t9;
        $[36] = t10;
    }
    else {
        t10 = $[36];
    }
    let t11;
    if ($[37] !== rightContent) {
        t11 = rightContent && <div className="hidden md:flex ml-4 flex-col self-stretch flex-shrink-0">{rightContent}</div>;
        $[37] = rightContent;
        $[38] = t11;
    }
    else {
        t11 = $[38];
    }
    let t12;
    if ($[39] !== containerClassName || $[40] !== t10 || $[41] !== t11) {
        t12 = <div className={containerClassName}>{t10}{t11}</div>;
        $[39] = containerClassName;
        $[40] = t10;
        $[41] = t11;
        $[42] = t12;
    }
    else {
        t12 = $[42];
    }
    let t13;
    if ($[43] !== belowContent || $[44] !== t12) {
        t13 = <>{t12}{belowContent}</>;
        $[43] = belowContent;
        $[44] = t12;
        $[45] = t13;
    }
    else {
        t13 = $[45];
    }
    return t13;
};
export default EntityCardMainContentTemplate;
